import '../../css/info_components/info_title.css'

function UpdateTitle() {
    return (
        <main>
            <div className='info_all_parent'>
                <font className='page_nav_font_active'>
                    Messages and Updates
                </font>
            </div>
        </main>
    );
}

export default UpdateTitle;